import React/*, { Component }*/, {useEffect, useState} from 'react';
import {Button, Input} from 'reactstrap';
import Modes from "../exercises/mode/Modes";
import ModeItem from "./modeItem/ModeItem";
import i18n from "i18next";

import "../style/SelectionPage.sass"
import getModesFromURL from "../ModeURLParameterHelper";
import {LOCALSTORAGE_DISCLAIMER_ACCEPTED} from "./MainPage";
import {useNavigate, useSearchParams} from "react-router-dom";

function SelectionPage({onModesSelected}){
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const [selectedModes, setSelectedModes] = useState(getModesFromURL(window.location.search))
    const [searchFilter, setSearchFilter] = useState("")

    const onModeClicked = (mode) => {
        // Create a copy that can be set later to update UI
        const _selectedModes = JSON.parse(JSON.stringify(selectedModes));
        if(_selectedModes[mode]){
            delete _selectedModes[mode];
        }else{
            _selectedModes[mode] = true;
        }
        setSelectedModes(_selectedModes)

        // Update URL
        setSearchParams({modes: Object.keys(_selectedModes).join(",")})
    };

    const filterModes = (e) => {
        const value = e.target.value;
        setSearchFilter(value)
    };

    const shouldModeBeFiltered = (key, mode) => {
        if(searchFilter.length === 0){
            return false;
        }
        const filterTerm = searchFilter.toLowerCase();
        const modeTitle = i18n.t(key).toLowerCase();
        let filter = false;
        if(modeTitle.indexOf(filterTerm)===-1){
            filter = true;
        }
        return filter;
    };

    const buildModeElements = (filter) => {
        const elements = [];
        Object.keys(Modes).forEach(key => {
            const mode = Modes[key];
            if(shouldModeBeFiltered(key, mode)){
                return;
            }

            const selected = selectedModes[key] === true ? "mode-card-selected" : "";
            elements.push(
                <li
                    key={"mode-"+key}
                    className={`${selected} mode-card-selection mode-card-title-full-height mode-card`}>
                    <ModeItem
                        key={"mode-item-"+key}
                        modeKey={key}
                        mode={mode}
                        onClick={onModeClicked}
                    />
                </li>
            )
        });
        return elements;
    };

    const startGame = () =>{
        onModesSelected(Object.keys(selectedModes));
        navigate("/practice?"+searchParams);
    };

    const clearSelection = () => {
        setSelectedModes({})
    };

    const showInfo = () => navigate("/info")

    useEffect(()=>{
        if(localStorage.getItem(LOCALSTORAGE_DISCLAIMER_ACCEPTED) !== "true"){
            // Redirect to disclaimer if it was not yet accepted
            console.log("Not accepted");
            navigate("/info")
        }
    })


    let listClassNames = "selection-page-list";
    let controls = <div/>;

    if(Object.keys(selectedModes).length > 0){
        listClassNames = listClassNames + " selection-page-list-with-selection";
        controls =  (
            <div className={"selection-page-controls"}>
                <Button onClick={clearSelection}>
                    <i className={"material-icons"}>clear</i>
                    Clear All
                </Button>
                <Button color={"primary"}  onClick={startGame}>Start</Button>
            </div>
        );
    }

    const modeElements = buildModeElements();
    return (
        <div>
            <div className={"selection-page-search"}>
                <Input
                    placeholder={i18n.t("search")}
                    onChange={filterModes}
                    value={searchFilter}
                />
                <i onClick={showInfo} className="material-icons">info</i>
            </div>
            <div className={listClassNames}>
                <ul>
                    {modeElements}
                </ul>
            </div>
            {controls}
        </div>
    )
}
export default SelectionPage
